module.exports = __webpack_public_path__ + "static/media/illustration.0b043dca.png";